import React from 'react';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/logo.jpeg';
import PG from '../../assets/pg-logo.png';

import Card from '../common/Card';

import './styles/works.css';

const Works = () => (
  <div className="works">
    <Card
      icon={faBriefcase}
      title="Work"
      body={(
        <div className="works-body">
          <div className="work">
            <img
              src={logo}
              alt="self-employed"
              className="work-image"
            />
            <div className="work-title">Self-Employed</div>
            <div className="work-subtitle">
              Full Stack Developer
            </div>
            <div className="work-duration">Feb 2023 - Present</div>
          </div>

          <div className="work">
            <img
              src={PG}
              alt="pg advertising"
              className="work-image"
            />
            <div className="work-title">P&G Advertising</div>
            <div className="work-subtitle">
              Account Clerk
            </div>
            <div className="work-duration">Sep 2021 - Dec 2022</div>
          </div>
        </div>
   )}
    />
  </div>
);

export default Works;
